
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/document-storage-services",
      function () {
        return require("private-next-pages/document-storage-services/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/document-storage-services"])
      });
    }
  